
import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { AuthenticationService } from './authentication.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpXsrfTokenExtractor } from '@angular/common/http';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
    private token: string;
    constructor(private router: Router, private toastr: ToastrService, private tokenExtractor: HttpXsrfTokenExtractor, private injector: Injector) { }

    intercept(request: HttpRequest < any >, next: HttpHandler): Observable < HttpEvent < any >> {
        this.token = localStorage.getItem('token');
        const headerName = 'X-XSRF-TOKEN';
        const auth = this.injector.get(AuthenticationService);
        const xrsfToken = this.tokenExtractor.getToken() as string;
        if (xrsfToken !== null && !request.headers.has(headerName)) {
            request = request.clone({ headers: request.headers.set(headerName, xrsfToken) });
        } else {
            request = request.clone({ headers: request.headers.set(headerName, document.cookie) });
        }
        if (this.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this.token}`
                }
            });
        }
        
        return next.handle(request).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                // do stuff with response if you want
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    if (auth.isLoggedIn()) {
                        this.toastr.error('CO0273: Your session has expired. Please login again', 'Warning');
                    }
                    //localStorage.clear();
                    this.router.navigate(['/auth/signin']);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/authentication/authentication-interceptor.ts